module.exports = __webpack_public_path__ + "static/media/adalogo.44bbe4b2.png";